<template>
  <div class="dashboard">
    <div class="flex justify-between items-center gap-6 mb-6 mdmax:flex-wrap mdmax:gap-2">
      <div class="flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start">
        <div class="">
          <p class="text-neutral-500 mdmax:text-sm">Total Agent</p>
          <p class="text-lg font-bold mb-6">0</p>
          <!-- <p class="text-xs">Tarkhir Update, Sep 20</p> -->
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-primary-100">
          <Courier color="neutral-700" height="18" width="18" />
        </span>
      </div>
      <div class="flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start">
        <div class="">
          <p class="text-neutral-500 mdmax:text-sm">Total Armada</p>
          <p class="text-lg font-bold mb-6">0</p>
          <!-- <p class="text-xs">Tarkhir Update, Sep 20</p> -->
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100">
          <Truck color="neutral-700" height="15" width="19" />
        </span>
      </div>
      <div class="flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start">
        <div class="">
          <p class="text-neutral-500 mdmax:text-sm">Request Pengiriman</p>
          <p class="text-lg font-bold mb-6">0</p>
          <!-- <p class="text-xs">Tarkhir Update, Sep 20</p> -->
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-primary-100">
          <Order color="neutral-700" height="18" width="18" />
        </span>
      </div>
      <div class="flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start">
        <div class="">
          <p class="text-neutral-500 mdmax:text-sm">Barang Terkirim</p>
          <p class="text-lg font-bold mb-6">0</p>
          <!-- <p class="text-xs">Tarkhir Update, Sep 20</p> -->
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100">
          <Delivered color="neutral-700" height="20" width="19" />
        </span>
      </div>
    </div>
    <!-- <div class="px-3 py-4 bg-white mb-6">
      <p class="text-lg font-bold mb-4">Pendapatan</p>
      <LineChart :data="lineChartData" :options="lineChartOption" />
    </div> -->
    <div class="px-3 py-4 bg-white mb-6" v-if="dataIsReady">
      <div class="flex justify-between items-center mb-2">
        <p class="text-lg font-bold">Request Pengiriman</p>
        <!-- <router-link to="/" class="inline-block text-primary-500 font-medium mdmax:text-sm">Lihat Semua</router-link> -->
      </div>
      <TableComponent compact :columns="columnsShipping" :list="pickupAssignment">
        <template slot="table-row" slot-scope="{ entry, column }">
          <span class="block" v-if="column.field === 'order_delivery_schedule'">{{ entry[column.field] | formatDate }}</span>
          <span class="block" v-else-if="column.field === 'sender'">{{ entry.sender.name }}</span>
          <span class="block" v-else-if="column.field === 'senderLocation'">{{ getAreaName(entry.sender.area_code) || '-' }}</span>
          <span class="block" v-else-if="column.field === 'receiver'">{{ entry.receiver.name }}</span>
          <span class="block" v-else-if="column.field === 'receiverLocation'">{{ getAreaName(entry.receiver.area_code) || '-' }} </span>
          <span v-else>{{ entry[column.field] }}</span>
        </template>
      </TableComponent>
    </div>
    <div class="px-3 py-4 bg-white">
      <div class="flex justify-between items-center mb-2">
        <p class="text-lg font-bold">Driver Assigment</p>
        <!-- <router-link to="/" class="inline-block text-primary-500 font-medium mdmax:text-sm ">Lihat Semua</router-link> -->
      </div>
      <TableComponent compact :columns="columnsArmada" :list="driverAssignment">
        <template slot="table-row" slot-scope="{ entry, column }">
          <span class="block" v-if="column.field === 'from_area_code'">{{ getAreaName(entry.from_area_code) || '-' }}</span>
          <span class="block" v-else-if="column.field === 'to_area_code'">{{ getAreaName(entry.to_area_code) || '-' }}</span>
          <span v-else>{{ entry[column.field] }}</span>
        </template>
      </TableComponent>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@/util'
export default {
  filters: {
    formatDate
  },
  components: {
    Courier: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Courier'),
    Truck: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Truck'),
    Order: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Order'),
    Delivered: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Delivered'),
    // LineChart: () => import(/* webpackChunkName: "chart" */ '@/components/Chart/LineChart'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table')
  },
  data: () => ({
    lineChartData: {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [
        {
          label: 'Pendapatan',
          backgroundColor: 'transparent',
          borderColor: '#59c8c1',
          data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        }
      ]
    },
    lineChartOption: { responsive: true, maintainAspectRatio: false },
    columnsArmada: [
      // { label: 'ID', field: 'id' },
      { label: 'Driver', field: 'name' },
      { label: 'Plat Armada', field: 'vehicle_plat_id' },
      { label: 'Asal', field: 'from_area_code' },
      { label: 'Tujuan', field: 'to_area_code' }
    ],
    columnsShipping: [
      { label: 'Tgl', field: 'order_delivery_schedule' },
      { label: 'Order Book', field: 'order_booking_code' },
      { label: 'Pengirim', field: 'sender' },
      { label: 'Lokasi Pengirim', field: 'senderLocation' },
      { label: 'Penerima', field: 'receiver' },
      { label: 'Lokasi Penerima', field: 'receiverLocation' }
    ],
    listShipping: [
      {
        date: '9 Oct 2021',
        bookCode: 'LN - 45325',
        sender: 'Arif Rahman',
        senderLocation: 'Jakarta',
        customer: 'Rahmat Wijaya',
        customerLocation: 'Bandung'
      },
      {
        date: '9 Oct 2021',
        bookCode: 'LN - 45325',
        sender: 'Arif Rahman',
        senderLocation: 'Jakarta',
        customer: 'Rahmat Wijaya',
        customerLocation: 'Bandung'
      }
    ],
    listArmada: [
      {
        id: 8232,
        name: 'Hartaka Darmanto',
        plat: 'F 9321 LK',
        from: 'Bogor',
        to: 'Jakarta Selatan'
      },
      {
        id: 8232,
        name: 'Hartaka Darmanto',
        plat: 'F 9321 LK',
        from: 'Bogor',
        to: 'Jakarta Selatan'
      }
    ],
    dataIsReady: false
  }),
  computed: {
    ...mapGetters('assignment', ['pickupAssignment', 'driverAssignment']),
    ...mapGetters('master', ['cities']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    }
  },
  created() {
    this.getPickupAssignmentList()
    this.getDriverAssignmentList()
    this.getCityList()
  },
  methods: {
    ...mapActions('assignment', ['getPickupAssignment', 'getDriverAssignment']),
    ...mapActions('master', ['getCities']),
    getAreaName(code) {
      return this.cities?.filter(item => item.code === code)[0]?.name
    },
    getCityList() {
      this.getCities({
        params: {
          page: 1,
          per_page: 1000,
          search_keyword: ''
        }
      })
    },
    getDriverAssignmentList() {
      this.getDriverAssignment({
        params: {
          page: 1,
          per_page: 8,
          search_keyword: '',
          sort: 'DESC'
        }
      })
    },
    getPickupAssignmentList() {
      this.getPickupAssignment({
        partnerId: this.partnerId,
        params: {
          page: 1,
          per_page: 8,
          search_keyword: '',
          sort: 'DESC'
        }
      }).then(() => {
        this.dataIsReady = true
      })
    }
  }
}
</script>
